import storage from '@/plugins/storage'
export default {
  setUserInfo (state, data) {
    state.userinfo = data
    storage.set('userinfo', data)
  },
  delUserInfo (state) {
    storage.del('userinfo')
    state.userinfo = {}
  },
  refreshUserInfo (state) {
    state.userinfo = storage.get('userinfo') || {}
  },
  delAppToken (state) {
    storage.del('token')
    state.isLogin = false
    state.token = ''
  },
  setLogin (state, flag) {
    state.isLogin = flag
  },
  setIsBindAlpha (state, isBindAlpha) {
    state.isBindAlpha = isBindAlpha
  },
  setSystemNotice (state, data) {
    console.log(data,'jjajajjsss')
    state.systemNotice = data
  },
  // 设置系统配置
  setSystemConfig (state, systemConfig) {
    state.systemConfig[systemConfig.key] = systemConfig.value
    // 将数据暂存到localStorage中
    storage.set('systemConfig', state.systemConfig)
  },
  setNoRenewalsConfig (state, noRenewals) {
    state.noRenewals[noRenewals.key] = noRenewals.value
    // 将数据暂存到localStorage中
    storage.set('noRenewals', state.noRenewals)
  },
  setDrainagePopVisible (state, data) {
    const { flag, enableSign } = data
    state.drainagePopVisible = flag
    if (enableSign === 0) {
      state.dialogConfig = state.systemConfig.weChatOrange
    }
    if (enableSign === 1) {
      state.dialogConfig = state.noRenewals.noRenewals
    }
  },
}
